// extracted by mini-css-extract-plugin
export var productImage = "_rc-1";
export var viewLink = "_rc-2";
export var wishlistItem = "_rc-0";